<template>
  <div class="content">
    <form>
      <kassaorder-form :datas="dataall"></kassaorder-form>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
      <asos :datas="dataall"></asos>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.order.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { KassaorderForm, Sklad, Paytype, Asos } from "@/pages";
export default {
  components: { KassaorderForm, Sklad, Paytype, Asos },
  data() {
    return {
      dataall: {
        datetime: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        dollar_rate:0,
        dollar_summa:0,
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        summa: 0,
        kassa_order_table: [
          {
            base_id: 0,
            summa: 0,
            pay_type_id: 0,
            type: false,
            comment: ""
          }
        ]
      }
    };
  },
   created: function() {
    let self=this;
    axios
        .get("api/v1/kassa-order/last-number")
        .then(function(response) {
            self.dataall.number=response.data.number;
            self.$store.state.saved = null;
        });
        axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.dataall.dollar_rate=response.data.rate;
            self.$store.state.saved = null;
        });
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Кассовий ордер" });
      }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved <2) {
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>
